import styled, { css } from 'styled-components';
import { colors } from 'global/colors';

export const TicketModalDescription = styled.p`
  font-size: 1rem;
`;

export const TicketContainer = styled.div`
  margin-bottom: 1rem;
`;

export const TicketModalSpan = styled.span``;

export const LanguagesAllowedContainer = styled.div`
  margin-bottom: 1rem;
`;

export const TicketLinkRow = styled.span`
  display: flex;
  flex-direction: row;
  gap: 5px;
  width: 100%;
  max-width: 100%;
`;

export const TicketLink = styled.input.attrs({ className: 'form-control' })`
  background-color: ${colors.lightGray};
  width: 91%;
  display: inline-block;
  &:focus {
    outline: 0 none !important;
    border-color: #e5e5e5;
  }
`;

export const CopyLinkButton = styled.a`
  cursor: pointer;
  background-color: ${colors.fsDarkBlue};
  color: ${colors.white};
  text-align: center;
  display: inline-block;
  margin-left: 5px;
  height: 38px;
  user-select: none;
  border-radius: 0.2rem;
  border: 1px solid transparent;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  &:hover {
    background-color: ${colors.fsDarkBlueHoverLight};
    color: ${colors.white};
    text-decoration: none;
  }
`;

export const CopyIcon = styled.i.attrs({ className: 'fa fa-copy' })`
  font-size: 1rem;
  width: 36px;
  line-height: 36px;
`;

export const TestNameLabel = styled.label`
  font-weight: bold;
`;

export const OptionsContainer = styled.span`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
`;

export const Question = styled.label`
  padding-top: 1rem;
  font-size: 14px;
`;

export const OptionAndLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 11px;
`;

export const OptionLabel = styled.label`
  text-align: center;
  cursor: pointer;
  :hover {
    font-weight: bold;
  }
`;

export const CommentTextArea = styled.textarea`
  width: 100%;
  resize: none;
  padding: 10px;
  height: 5rem;
  min-height: 5rem;
`;

export const CloseButton = styled.button`
  outline: 0;
  line-height: 10px;
  font-size: 25px;
  color: #505050;
  text-shadow: none;
  opacity: 1;
  cursor: pointer;
  padding: 15px;
  position: absolute;
  right: 0;
  top: 0;
  border: none;
  background: white;
  font-weight: 600;
`;
